import React, { useEffect, useMemo } from "react";
import { useAppQuery } from "../../api/fetchClient";
import { GET_LAUNGUGE } from "../../api/url";
import { QUERY_KEYS } from "../../api/queryKeys";
import Loader from "./Loader";
import { strings } from "../../strings/strings";

const extractLanguages = (languagesData) => {
  const languagesArray = languagesData?.results?.languages || languagesData?.data?.languages || [];

  if (!Array.isArray(languagesArray)) {
    return [];
  }

  const allLanguages = languagesArray.map((lang) => lang?.language_name || lang?.native_name).filter((lang) => lang);

  return allLanguages;
};

const LanguageTabs = ({
  languages: providedLanguages = [],
  activeLanguage,
  onLanguageChange,
  variant = "tabs",
  className = "",
  useApi = false,
  autoSelectFirst = false,
  showLoader = true,
}) => {
  const { data: languagesData, isLoading: isLanguagesLoading } = useAppQuery({
    queryKey: QUERY_KEYS.LANGUAGES,
    url: GET_LAUNGUGE,
    method: "GET",
    enabled: useApi,
  });

  const languages = useMemo(() => {
    if (useApi && languagesData) {
      return extractLanguages(languagesData);
    }
    return providedLanguages;
  }, [useApi, languagesData, providedLanguages]);

  useEffect(() => {
    if (useApi && autoSelectFirst && languages.length > 0 && !activeLanguage && onLanguageChange) {
      onLanguageChange(languages[0]);
    }
  }, [useApi, autoSelectFirst, languages, activeLanguage, onLanguageChange]);

  if (useApi && isLanguagesLoading && showLoader) {
    return (
      <div className={className}>
        <Loader />
      </div>
    );
  }

  if (languages.length === 0) {
    return (
      <div className={className}>
        <p className="text-sm text-gray-500 px-4 py-4">{strings.nolaungugeavailable}</p>
      </div>
    );
  }

  if (variant === "buttons") {
    return (
      <div className={`flex gap-2 ${className}`}>
        {languages.map((lang) => {
          const isActive = activeLanguage?.toLowerCase() === lang?.toLowerCase();
          return (
            <button
              key={lang}
              onClick={() => onLanguageChange && onLanguageChange(lang)}
              className={`px-4 py-1.5 rounded-lg text-sm font-medium border transition-colors ${
                isActive
                  ? "bg-primary text-white border-primary"
                  : "bg-white text-secondary border-transparent hover:border-primary"
              }`}
            >
              {lang}
            </button>
          );
        })}
      </div>
    );
  }

  return (
    <div className={`flex gap-10 ${className}`}>
      {languages.map((lang) => (
        <button
          key={lang}
          onClick={() => onLanguageChange(lang)}
          className={`px-4 py-4 font-medium border-b-2 transition-colors ${
            activeLanguage === lang ? "border-primary text-primary" : "border-transparent hover:text-primary"
          }`}
        >
          {lang}
        </button>
      ))}
    </div>
  );
};

export default LanguageTabs;
